import { TaxStatusEnum } from "app/utility/enums";

export type PriceEditorMode = 'simple' | 'extended';

export class PriceEditorModel {
	title: string;
	mode: PriceEditorMode;
	removeTaxTypes: boolean;
	id: string;
	editableCurrency: boolean;
    editableTaxRate: boolean;

	price: {id: string, value: number};
	taxType: {id: string, value: number | TaxStatusEnum};
	taxRate: {id: string, value: number};
	taxAmount: {id: string, value: number};
	currency: {id: string, value: string};
}
